import { ActionType } from "@/models/enum-types/action-type.enum";
import IDeviceStore from "@/models/modelStore/IDeviceStore";
import DeviceViewData from "@/models/modelView/IDeviceView";
import { ModemStrategy } from "./modem.strategy";
import IPosition from "@/models/dto/position.dto";
import CommandsService from "@/api/services/commands.service";
import DeviceUtil from "@/utils/device.util";
import IDataInfo from "@/models/modelView/IDataInfo";

export default class WetrackStrategy extends ModemStrategy {
    getExtraAttributes(attributes: any): IDataInfo[] {
        return [{ title: 'Odo:', value: (attributes.totalDistance / 1000).toFixed(2) + ' Km' }]
    }
    getReportDetails(data: IPosition[], device: IDeviceStore) {
        return this.genericReportDetails(data, device)
    }

    customAttributes: any[] = [
        { name: "sat", viewName: "Satelites:", suffix: '' },
    ]

    async sendCommand(deviceId: number, type: ActionType) {
        let command = ''
        switch (type) {
            case ActionType.RESET:
                command = 'RESET#'
                break;
            case ActionType.LOCK_COMMAND:
                command = 'RELAY,1#'
                break;
            case ActionType.UNLOCK_COMMAND:
                command = 'RELAY,0#'
                break;
            default:
                break;
        }
        await CommandsService.sendCommand(command, deviceId)
    }

    mapDevice(device: IDeviceStore): DeviceViewData {
        return {
            data_icons: this.mapIcons(device),
            data_info: this.mapAttributes(device.position?.attributes,device),
            icon: device.icon || '0',
            id: device.id,
            plate: device.name,
            time: device.position?.deviceTime || device.position?.serverTime || device.position?.fixTime || '',
            speed: DeviceUtil.formatKnToKmh(device.position?.speed)
        }
    }

    mapIcons(device: IDeviceStore) {
        const attributes = device?.position?.attributes;
        const array = []
        if (attributes?.ignition) {
            array.push({
                classes: ['icon-data', 'key-green'],
                src: require('@/assets/img/key-green.svg'),
                extra: ''
            })
        } else {
            array.push({
                classes: ['icon-data', 'key-red'],
                src: require('@/assets/img/key-red.svg'),
                extra: ''
            })
        }
        if (attributes?.blocked) {
            array.push({
                classes: ['icon-data', 'locked-car'],
                src: require('@/assets/img/locked-car.svg'),
                extra: ''
            })
        }
        array.push({
            classes: ['icon-data', 'battery-gps'],
            src: require('@/assets/img/battery-gps.svg'),
            extra: (device.position?.attributes?.batteryLevel || '-') + "%"
        })

        return array
    }

}